var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38573 10.5323C8.18573 10.7748 7.81426 10.7748 7.61427 10.5323L4.34466 6.56814C4.07569 6.24202 4.30766 5.75 4.73039 5.75L11.2696 5.75C11.6923 5.75 11.9243 6.24202 11.6553 6.56814L8.38573 10.5323Z",
    fill: "#4050A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBlue);
export default __webpack_public_path__ + "static/media/dropdown_blue.5c5019e7664d3ff699c1e9c0630e906b.svg";
export { ForwardRef as ReactComponent };